import { render, staticRenderFns } from "./AppDownloadSquare.vue?vue&type=template&id=7780a5f5&scoped=true&"
import script from "./AppDownloadSquare.vue?vue&type=script&lang=js&"
export * from "./AppDownloadSquare.vue?vue&type=script&lang=js&"
import style0 from "./AppDownloadSquare.vue?vue&type=style&index=0&id=7780a5f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7780a5f5",
  null
  
)

export default component.exports